<gcp-workspace-error-state
  heading="Something went wrong"
  message="Sorry, an unexpected error occurred. Please try again later."
>
  <button mat-raised-button color="primary" (click)="goToHome()">
    Go back to Home
  </button>
  <!-- Escape hatch: this page is where broken-session states converge, so
       it must always offer a way to end the session. -->
  <button mat-stroked-button data-cy="error-signout" (click)="signOut()">
    Sign out
  </button>
</gcp-workspace-error-state>
